import { render, staticRenderFns } from "./IncomeReadOnly.vue?vue&type=template&id=723b96cc"
import script from "./IncomeReadOnly.vue?vue&type=script&lang=js"
export * from "./IncomeReadOnly.vue?vue&type=script&lang=js"
import style0 from "./IncomeReadOnly.vue?vue&type=style&index=0&id=723b96cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports